module.exports = __webpack_public_path__ + "static/media/usedsoloshow18.ae3814d9.JPG";